import React, { useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { Button } from 'primereact/button';

import axios from "axios"
import { json } from 'd3';
import DeletionDialog from '../../components/DeletionDialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';

export const FileDetails = (props) => {

    const location = useLocation();
    const [name, setName] = useState(null);
    const [data, setData] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editState, setEditState] = useState({});
    const [fileDidUpdate, setFileDidUpdate] = useState(true); 
    const {id} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = `File Details | Palmona Pathogenomics`
    }, []);

    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

    function getSessionStorageOrDefault(key, defaultValue) {
        const stored =  sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
    
      }

    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );

    const deleteFile = async (fileId) => {

        try {

          const method = 'PUT';

          const body = new FormData();
          body.append("isDeleted", true);

          const headers = {
            'Authorization': `Bearer ${getDataUserToken}`,
          }

          fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/file/${fileId}`,
          {
            method,
            headers,
            body
          })
                .then(res => {
                    if (res.ok) {
                        // props.history.push('/files');
                        // props.history.push('/datasets/files');
                        // console.log('file deleted');
                        navigate("/datasets/files");
                    }
                })
        }
        catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }
    
    useEffect(() => {

      if (!fileDidUpdate) return;
        const getFile = async () => {
          try {
            fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/file/${id}?userId=${userid}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getDataUserToken}`,
                }
            })
                .then(res => res.json())
                .then(val => {
                  setData(val);
                  setLoading(false);
                  setFileDidUpdate(false);
                })
          } catch (err) {
            setError(err.message);
            setData(null);
            setLoading(false);
          }
        };
        getFile();
    }, [id, userid, fileDidUpdate]);

    let attributeMap = {};
    if (data?.fileattributes) data.fileattributes.forEach(att => {
      attributeMap[att.name] = att.value;
    });
    if (Object.keys(attributeMap).length && !Object.keys(editState).length) setEditState(attributeMap);

    const fileTypeOptions = ['paired_end', 'single_end', 'pacbio', 'fasta'];

    const saveCurrentAttributes = () => {
      const idsToDelete = [];
      const attsToAdd = {};
      const typeDidChange = editState.type !== attributeMap.type;
      const directionDidChange = editState.direction !== attributeMap.direction && editState.direction;
      const pbfileDidChange = editState.pbfile !== attributeMap.pbfile && editState.pbfile;
      if (typeDidChange) attsToAdd.type = editState.type;
      if (directionDidChange) attsToAdd.direction = editState.direction;
      if (pbfileDidChange) attsToAdd.pbfile = editState.pbfile;

      data.fileattributes.forEach(attribute => {
        if (typeDidChange && attribute.name === 'type') idsToDelete.push(attribute.id);
        if ((editState.type !== 'paired_end' || directionDidChange) && attribute.name === 'direction') idsToDelete.push(attribute.id)
        if ((editState.type !== 'pacbio' || pbfileDidChange) && attribute.name === 'pbfile') idsToDelete.push(attribute.id);
      });

      Promise.all([
        Promise.all(idsToDelete.map(id => 
          fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/file_attribute/' + id, {
            method: 'DELETE',
            headers: {
              Authorization: `Bearer ${getDataUserToken}`,
            }
          })
            .then(res => res.json())
            .catch(err => console.error(err))
        )),
        Promise.all(Object.entries(attsToAdd).map(([name, value]) => {
          const body = new FormData();
          body.append('name', name);
          body.append('value', value);
          body.append('fileId', data.id);
          return fetch(process.env.REACT_APP_WORKFLOW_API_PATH + 'wfapi/file_attribute', {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${getDataUserToken}`,
            },
            body
          })
            .then(res => res.json())
            .catch(err => console.error(err));
        }))
      ])
        .then(conf => {
          setFileDidUpdate(true);
          setEditMode(false);
        })
    }

    const fileIsDeleted = data.isDeleted ? 'Deleted' : 'Not Deleted';

    let saveEditDisabled = true;
    if (editState.type !== attributeMap.type) saveEditDisabled = false;
    if (editState.direction !== attributeMap.direction) saveEditDisabled = false;
    if (editState.pbfile !== attributeMap.pbfile) saveEditDisabled = false;
    if (editState.type === 'paired_end' && !editState.direction) saveEditDisabled = true;
    if (editState.type === 'pacbio' && !editState.pbfile) saveEditDisabled = true;

    if (loading) return (
      <div className="surface-card p-4 shadow-2 border-round">
        <div className="font-medium text-3xl text-900 mb-3">File Details</div>
        <ProgressSpinner />
      </div>
    )
    console.log(editState);

    return (
      <div className="surface-card p-4 shadow-2 border-round">
      <div className="font-medium text-3xl text-900 mb-3">File Details</div>
      {/* <div className="text-500 mb-5">Morbi tristique blandit turpis. In viverra ligula id nulla hendrerit rutrum.</div> */}
      <ul className="list-none p-0 m-0">
      < li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">ID</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.id || `File ${id} Not Found`}</div>
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Name</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.name}</div>
          </li>
          {/* <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Created By</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.createdByUsername}</div>
          </li> */}
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Last Updated</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.updatedAt}</div>
          </li>
          {/* <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Last Aggregated</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.lastAggregation || 'Never'}</div>
          </li> */}
          {/* <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Privacy</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data.is_public ? 'Public' : 'Private'}</div>
          </li> */}
          {/* <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Attributes</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                {data.datasetattributes && data.datasetattributes.map(attribute => <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{attribute.name}: {attribute.value}</div>)}
                {(!data.datasetattributes || !data.datasetattributes.length) && <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">None</div>}
              </div>    
          </li> */}
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">File Type</div>
              {editMode === false && <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{attributeMap.type || 'none'}</div>}
              {editMode === true && <Dropdown value={editState.type} onChange={(e) => {
                const newEditState = {...editState};
                newEditState.type = e.value;
                setEditState(newEditState);
              }} options={fileTypeOptions}/>}
          </li>
          {editState.type === 'paired_end' && <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Direction</div>
              {editMode === false && <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{attributeMap.direction}</div>}
              {editMode === true && <Dropdown value={editState.direction} onChange={e => {
                const newEditState = {...editState};
                newEditState.direction = e.value;
                setEditState(newEditState);
              }} options={['forward', 'reverse']}/>}
          </li>}
          {editState.type === 'pacbio' && <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Pacbio File</div>
              {editMode === false && <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{attributeMap.pbfile}</div>}
              {editMode === true && <Dropdown value={editState.pbfile} onChange={e => {
                const newEditState = {...editState};
                newEditState.pbfile = e.value;
                setEditState(newEditState);
              }} options={['bam', 'pbi']}/>}
          </li>}
            <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Deleted</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{fileIsDeleted}</div>
          </li>
      </ul>
      <DeletionDialog visible={deleteVisible} setVisible={setDeleteVisible} deleteCallback={() => deleteFile(data.id)} type='file' name={data.name}/>
      <div className="flex justify-end mt-5">
          {!editMode && <Button label="Edit" className='mr-3' onClick={() => setEditMode(true)} />}
          {editMode && <Button label="Save Changes" className='mr-3' onClick={() => saveCurrentAttributes(true)} disabled={saveEditDisabled} />}
          {editMode && <Button label="Discard Changes" className='mr-3' onClick={() => {setEditMode(false); setEditState(attributeMap)}} />}
          <Button label="Delete File" onClick={() => setDeleteVisible(true)} disabled={data.isDeleted} />
        </div>
  </div>
    )

}
export default FileDetails;